var exports = {
  "k": "xfd349460--bdf989--container",
};

module.exports = exports;
